import React from 'react';
import { Box, Divider, Typography } from '@mui/material';
import { usePreviewRemarks } from '../hooks';

const RemarksSection: React.FC = () => {
  const remarks = usePreviewRemarks();

  if (!remarks) return null;

  return (
    <Box sx={{ mb: 3 }}>
      <Typography
        variant="subtitle1"
        sx={{
          fontWeight: 700,
          textTransform: 'uppercase',
          letterSpacing: '0.05em',
          color: 'text.primary',
          mb: 1,
        }}
      >
        Public Remarks
      </Typography>
      <Divider sx={{ mb: 1 }} />
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ whiteSpace: 'pre-wrap', py: 1 }}
      >
        {remarks}
      </Typography>
    </Box>
  );
};

export default React.memo(RemarksSection);
